import { ALL_CATEGORIES } from '../common/constants';
import Amplifier from '../../assets/images/archetypes/amplifier.png';
import Builder from '../../assets/images/archetypes/builder.png';
import Grounder from '../../assets/images/archetypes/grounder.png';
import Strategist from '../../assets/images/archetypes/strategist.png';
import Uplifter from '../../assets/images/archetypes/uplifter.png';
import VisionCrafter from '../../assets/images/archetypes/visionCrafter.png';

export const DEFAULT_MAX_CATEGORIES_DISPLAY = 3;

function toTags({ label, value }) {
  return {
    tag: label,
    value,
  };
}

const getCategoryOptions = categories => {
  return {
    label: 'Categories',
    maxCounter: categories.length,
    options: categories.map(toTags),
  };
};

const EthnicityOptions = {
  label: 'Ethnicities',
  maxCounter: 6,
  options: [
    { tag: 'African', value: 'African' },
    { tag: 'Afrolatine', value: 'Afrolatine' },
    { tag: 'Andean-descend', value: 'AndeanDescend' },
    { tag: 'Black', value: 'Black' },
    { tag: 'Black American', value: 'BlackAmerican' },
    { tag: 'Black Caribbean', value: 'BlackCaribbean' },
    { tag: 'Caucasian (White)', value: 'Caucasian' },
    { tag: 'Central Asian', value: 'CentralAsian' },
    { tag: 'East Asian', value: 'EastAsian' },
    { tag: 'Indigenous', value: 'Indigenous' },
    { tag: 'Jewish', value: 'Jewish' },
    { tag: 'Latine', value: 'Latine' },
    { tag: 'Middle Eastern', value: 'MiddleEastern' },
    { tag: 'Native American or Alaska Native', value: 'NativeAmerican' },
    { tag: 'Native Hawaiian or Pacific Islander', value: 'PacificIslander' },
    { tag: 'Other', value: 'Other' },
    { tag: 'South Asian', value: 'SouthAsian' },
    { tag: 'Southeast Asian', value: 'SoutheastAsian' },
  ],
};

const PronounOptions = {
  label: 'Pronouns',
  maxCounter: 3,
  options: [
    { tag: 'she/her', value: 'she/her' },
    { tag: 'he/him', value: 'he/him' },
    { tag: 'they/them', value: 'they/them' },
    { tag: 'ze/zir', value: 'ze/zir' },
    { tag: 'xe/xim', value: 'xe/xim' },
    { tag: 'co/co', value: 'co/co' },
    { tag: 'ey/em', value: 'ey/em' },
    { tag: 've/ver', value: 've/ver' },
    { tag: 'per/per', value: 'per/per' },
  ],
};

const ValueOptions = {
  label: 'values',
  maxCounter: 5,
  options: [
    { tag: 'Accuracy', value: 'Accuracy' },
    { tag: 'Authenticity', value: 'Authenticity' },
    { tag: 'Availability', value: 'Availability' },
    { tag: 'Communication', value: 'Communication' },
    { tag: 'Punctuality', value: 'Punctuality' },
    { tag: 'Respect', value: 'Respect' },
    { tag: 'Return/Exchange available', value: 'Return/Exchange available' },
    { tag: 'Quality', value: 'Quality' },
    { tag: 'Transparency', value: 'Transparency' },
  ],
};

const ARCHETYPE_DECORATOR = {
  'The Amplifier': {
    color: '#EAB53D',
    secondaryColor: '#EAB53D50',
    image: Amplifier,
    icon: '📢',
    strengths: 'Messaging, marketing, social influence',
    bestMatch: 'The Uplifter',
    matchReason:
      'Amplifiers know how to get attention, while Uplifters know how to build trust and depth. Together, they grow communities with both heart and hype.',
  },
  'The Builder': {
    color: '#749E7F',
    secondaryColor: '#749E7F50',
    image: Builder,
    icon: '💻',
    strengths: 'Technical know-how, execution, and digital problem-solving',
    bestMatch: 'The Vision Crafter',
    matchReason:
      'Builders create structure and function, while Vision Crafters add design and emotional resonance. One makes it work, the other makes it wow.',
  },
  'The Strategist': {
    color: '#74885C',
    secondaryColor: '#74885C50',
    image: Strategist,
    icon: '🧭',
    strengths: 'Big-picture planning, business sense, long-term thinking',
    bestMatch: 'The Builder',
    matchReason:
      'The Strategist knows what to build, and the Builder knows how to build it. Together, they turn business plans and bold ideas into working products.',
  },
  'The Vision Crafter': {
    color: '#E48834',
    secondaryColor: '#E4883450',
    image: VisionCrafter,
    icon: '🎨',
    strengths: 'Visual storytelling, creative direction, content creation',
    bestMatch: 'The Amplifier',
    matchReason:
      'Vision Crafters bring the art; Amplifiers get it seen. This duo can take an idea, brand, or campaign and make it both beautiful and viral.',
  },
  'The Uplifter': {
    color: '#DD896D',
    secondaryColor: '#DD896D50',
    image: Uplifter,
    icon: '🚀',
    strengths: 'Mentorship, career support, emotional intelligence',
    bestMatch: 'The Strategist',
    matchReason:
      'Uplifters guide and encourage growth, while Strategists provide clarity on direction. This match turns motivation into real momentum.',
  },
  'The Grounder': {
    color: '#93A268',
    secondaryColor: '#93A26850',
    image: Grounder,
    icon: '🧘',
    strengths: 'Routines, wellness, emotional stability',
    bestMatch: 'The Amplifier',
    matchReason:
      'Grounders keep things steady, while Amplifiers push for momentum. Together, they create sustainable impact—hustle with heart.',
  },
};

export {
  ALL_CATEGORIES,
  ARCHETYPE_DECORATOR,
  getCategoryOptions,
  PronounOptions,
  EthnicityOptions,
  ValueOptions,
};
